import { call, put, takeEvery } from 'redux-saga/effects';
import { AddDpNewsFeedTag, DpNewsFeedActionKeys } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { IDpNewsFeedTag, lookupActionCreators } from '../../lookups';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { addDpNewsFeedTag } from '../dpNewsFeedApi';

function* addDpNewsFeedTagSaga(action: AddDpNewsFeedTag) {
  yield put(uiActionCreators.toggleLoading('addDpNewsFeedTag'));
  const response: IApiExecuteRespone<IDpNewsFeedTag> = yield call(addDpNewsFeedTag, action.payload.tag);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(lookupActionCreators.setLookups({ partial: true, payload: { dpNewsFeedTags: [response.value] } }));
  }

  yield put(uiActionCreators.toggleLoading('addDpNewsFeedTag'));
}

export function* watchAddDpNewsFeedTag() {
  yield takeEvery(DpNewsFeedActionKeys.ADD_DP_NEWS_FEED_TAG, addDpNewsFeedTagSaga);
}
